import React, { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../services/api';
import { Card, Label, Input, Button } from '../components/ui';

export default function ServicosScreen() {
  const [servicos, setServicos] = useState([]);
  const [novo, setNovo] = useState({ descricao: '', preco_padrao: '' });

  useEffect(() => { 
    carregar(); 
  }, []);

  const carregar = () => {
    api.get('/servicos').then(res => setServicos(res.data)).catch(err => console.error(err));
  };

  const adicionar = async () => {
    if (!novo.descricao) return;
    try {
      const precoTratado = parseFloat(novo.preco_padrao.toString().replace(',', '.')) || 0;
      await api.post('/servicos', { 
        descricao: novo.descricao, 
        preco_padrao: precoTratado 
      });
      toast.success("Serviço adicionado ao catálogo!");
      setNovo({ descricao: '', preco_padrao: '' }); 
      carregar();
    } catch (err) {
      toast.error("Erro ao adicionar serviço.");
    }
  };

  const deletar = async (id) => {
    try {
      await api.delete(`/servicos/${id}`); 
      toast.success("Serviço removido.");
      carregar();
    } catch (err) {
      toast.error("Erro ao deletar serviço.");
    }
  };

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">Serviços Base</h2>
        <p className="text-slate-500">Catálogo de serviços para seleção rápida na OS.</p>
      </div>

      <Card className="p-6">
        <div className="flex flex-col sm:flex-row gap-3 mb-6 items-start sm:items-end">
          <div className="w-full sm:flex-1">
            <Label>Descrição</Label>
            <Input placeholder="Ex: Formatação, Troca de Tela..." value={novo.descricao} onChange={e => setNovo({...novo, descricao: e.target.value})} />
          </div>
          <div className="w-full sm:w-32">
            <Label>Preço (R$)</Label>
            <Input type="text" placeholder="0,00" value={novo.preco_padrao} onChange={e => setNovo({...novo, preco_padrao: e.target.value})} />
          </div>
          <Button onClick={adicionar} className="w-full sm:w-auto">
            <Plus size={18} className="mr-2"/> Adicionar
          </Button>
        </div>

        <div className="space-y-2">
          {servicos.map(s => (
            <div key={s.id} className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-0 p-3 bg-slate-50 border rounded-md">
              <span className="font-medium text-slate-700 break-words w-full sm:w-auto">{s.descricao}</span>
              <div className="flex items-center justify-between w-full sm:w-auto gap-4">
                <span className="text-slate-600 font-mono">R$ {s.preco_padrao.toFixed(2).replace('.', ',')}</span>
                <Button variant="destructive" className="h-8 px-2" onClick={() => deletar(s.id)}>
                  <Trash2 size={16} />
                </Button>
              </div>
            </div>
          ))}
          {servicos.length === 0 && (
            <p className="text-center text-slate-500 text-sm py-4">Nenhum serviço cadastrado.</p>
          )}
        </div>
      </Card>
    </div>
  );
}